import CRUD from "@/firebase/crud";
import store from "@/store/index";

const Settings = {
  namespaced: true,
  state: {
    Portals: {},
    Documents: [],
    Document: null,
    DocumentResult: {},
    Lookups: []
  },
  getters: {},
  mutations: {
    setDocuments(state, data) {
      state.Documents = data;
    },
    setDocument(state, data) {
      state.Document = data;
    },
    setDocumentResult(state, data) {
      state.DocumentResult = data;
    },
    setPortals(state, data) {
      state.Portals = data;
    },
    setLookups(state, data) {
      state.Lookups = data;
    },
  },
  actions: {
    createDocument: async ({ commit }, payload) => {
      // // console.log(commit);
      try {
        let Collection = payload[0];
        let Data = payload[1];
        // let Mutation = payload[2];
        let Result = Promise.resolve(CRUD.CreateDocument(Collection, Data));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            case "failure":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Settings/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    readDocuments: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(
          CRUD.ReadDocuments(Collection, portalID, null)
        );
        //console.log("PAAAAYLOAD = " + JSON.stringify(payload, null, 2));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              // // console.log("SUCCESSSSSSSSSSSSSSSSSSS")
              // // console.log(Response)
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Settings/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // store.commit("Settings/setDocumentResult", "Error");
        // console.log(err);
      }
    },
    updateDocument: async ({ commit }, payload) => {
      // // console.log(commit);
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let Data = payload[2];
        let Result = Promise.resolve(CRUD.UpdateDocument(Collection, ID, Data));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            case "failure":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Settings/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    deleteDocument: async ({ commit }, payload) => {
      // // console.log(commit);
      try {
        let Collection = payload[0];
        let ID = payload[1];
        // let Mutation = payload[2];
        let Result = Promise.resolve(CRUD.DeleteDocument(Collection, ID));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("Settings/setDocumentResult", Response.message);
              console.log("delete success");
              break;
            case "failure":
              store.commit("Settings/setDocumentResult", Response.message);
              console.log("delete failure");
              break;
            case "error":
              store.commit("Settings/setDocumentResult", Response);
              console.log("delete error");
              break;
            default:
              store.commit("Settings/setDocumentResult", Response.message);
              console.log("delete:" + Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    readPortals: async ({ commit }) => {
      // // console.log(commit);
      try {
        let Collection = "portals";
        let Mutation = "Settings/setPortals";
        store.commit(Mutation, []);
        let Result = Promise.resolve(CRUD.readPortals(Collection));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            case "error":
              store.commit("Settings/setDocumentResult", Response.message);
              break;
            default:
              store.commit("Settings/setDocumentResult", Response.message);
              break;
          }
        });
      } catch (err) {
        store.commit("Settings/setDocumentResult", "Error");
      }
    },
    readLookups: async ({ commit }, payload) => {
      // // console.log(commit);
      try {
        let portalID = payload[0];
        let Collection = "lookups";
        let Mutation = "Settings/setLookups";
        store.commit(Mutation, []);
        if (portalID !== undefined) {
          let Result = Promise.resolve(
            CRUD.ReadDocuments(Collection, portalID, null)
          );
          Result.then(Response => {
            switch (Response.result) {
              case "success":
                store.commit(Mutation, Response.data);
                break;
              case "failure":
                store.commit("Settings/setDocumentResult", Response.message);
                break;
              case "error":
                store.commit("Settings/setDocumentResult", Response.message);
                break;
              default:
                store.commit("Settings/setDocumentResult", Response.message);
                break;
            }
          });
        } else {
          // Return Nothing Emtpy Lookups
        }
      } catch (err) {
        store.commit("Settings/setDocumentResult", "Error");
      }
    }
  }
};

export default Settings;
